module.exports = __webpack_public_path__ + "assets/img/pbtrade_product_4.b8566791.png";